import { FeatureFlag } from '../FeatureFlag';

export const autoCreateAlertsFromChannel = new FeatureFlag({
    key: 'auto-create-alerts-from-channel',
    defaultValue: false,
});
